module.exports = __webpack_public_path__ + "static/losgatos-34128ae522a64cf5b85ed256fbdc5ad4.jpg";